// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"8fb22a2e","581":"0b49200a","918":"c1a4ef76"}[chunkId] + ".chunk.js";
};